import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import React from "react";
import ListItemText from "@material-ui/core/ListItemText";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddUserToMerchant from "../AddUserToMerchant/AddUserToMerchant";
import swal from "sweetalert";
import { _post } from "../../Api";

export default function MerchantUsers(props) {
  const [merchantUsers, setMerchantUsers] = React.useState(
    props.merchant && props.merchant.permissions && props.merchant.permissions[0]
      ? props.merchant.permissions[0].users
      : []
  );
  const [dialogOpen, setDialogOpen] = React.useState(false);

  if (
    props.merchant &&
    props.merchant.permissions &&
    props.merchant.permissions[0] &&
    JSON.stringify(props.merchant.permissions[0].users) !== JSON.stringify(merchantUsers)
  ) {
    setMerchantUsers(props.merchant.permissions[0].users);
  }

  const removeUser = (i) => {
    _post("/nova/permissions/merchant/" + props.merchant.merchant_id + "/users/delete", {
      merchantId: props.merchant.merchant_id,
      users: [merchantUsers[i]],
    })
      .then(() => {
        merchantUsers.splice(i, 1);
        setMerchantUsers([...merchantUsers]);
      })
      .catch(() => {
        swal({
          title: "Oops!",
          text: "Something went wrong.",
          icon: "error",
        });
      });
  };

  const handleDialog = () => {
    setDialogOpen(true);
  };

  const addSelectedUser = (user) => {
    if (
      merchantUsers.some((userInMerchant) => {
        return userInMerchant.id === user.id;
      })
    ) {
      return;
    }
    _post("/nova/permissions/merchant/" + props.merchant.merchant_id + "/users", {
      merchantId: props.merchant.merchant_id,
      users: [user],
    })
      .then(() => {
        merchantUsers.push(user);
        setMerchantUsers([...merchantUsers]);
      })
      .catch(() => {
        swal({
          title: "Oops!",
          text: "Something went wrong.",
          icon: "error",
        });
      });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <List>
        {merchantUsers
          ? merchantUsers.map((user, i) => {
              return (
                <ListItem key={user.id}>
                  <ListItemIcon>
                    <HighlightOffIcon onClick={() => removeUser(i)} />
                  </ListItemIcon>
                  <ListItemText>{user.email}</ListItemText>
                </ListItem>
              );
            })
          : console.log("bla")}
      </List>
      <Button variant="outlined" onClick={() => handleDialog(merchantUsers)}>
        Add user
      </Button>
      <div>
        <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} scroll="paper">
          <DialogTitle>Add user</DialogTitle>
          <AddUserToMerchant selectedUsers={merchantUsers} addSelectedUser={addSelectedUser} />
        </Dialog>
      </div>
    </div>
  );
}
